import { useQuery } from '@apollo/client';
import { GET_UPCOMING_RACES_MINIMAL } from '../../graphql/queries/upcomingRacesMinimal';
import { GET_UPCOMING_RACES_TEASER } from '../../graphql/queries/upcomingRacesTeaser';
import { useBrand } from '../brand';
import { useViewer } from '../shell';
import { UpcomingTips } from './components';
import { upcomingRows, type UpcomingRow } from './lib';

/**
 * The next races with a tip, across every track. Subscribers get their picks;
 * signed-out visitors and non-subscribers see where the next tips are, locked.
 */
export function useUpcoming(): { upcoming: UpcomingRow[]; rows: UpcomingRow[]; locked: boolean; authed: boolean } {
  const brand = useBrand();
  const viewer = useViewer();
  const authed = viewer.isAuthenticated;
  const upcomingQ = useQuery(GET_UPCOMING_RACES_MINIMAL, {
    // no limit: the server returns every upcoming race today; "Next N" reveals them
    variables: { analysisTypeId: viewer.analysisTypeId || 1 },
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-and-network',
    pollInterval: 60000,
    skip: !authed,
  });
  const teaserQ = useQuery(GET_UPCOMING_RACES_TEASER, {
    variables: { limit: brand.upcomingShown },
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-and-network',
    pollInterval: 60000,
    skip: authed && viewer.isSubscribed,
  });
  const upcoming = upcomingRows(upcomingQ.data?.upcomingRacesMinimal, Date.now());
  const locked = !upcoming.length;
  return { upcoming, rows: locked ? upcomingRows(teaserQ.data?.upcomingRacesTeaser, Date.now()) : upcoming, locked, authed };
}

/** The upcoming-tips strip on its own, for pages that don't need the rows themselves. */
export function LiveUpcomingTips() {
  const { rows, locked, authed } = useUpcoming();
  return <UpcomingTips rows={rows} locked={locked} signedOut={!authed} />;
}
